// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as PositionSquare2 from "../player/PositionSquare2.bs.js";
import * as PlShortMatchSummary from "../player/PlShortMatchSummary.bs.js";

function PlCurrentPerformance$Cell(Props) {
  var suffix = Props.suffix;
  var icon = Props.icon;
  var num = Props.num;
  var label = Props.label;
  var numFontSizeOpt = Props.numFontSize;
  var numFontSize = numFontSizeOpt !== undefined ? numFontSizeOpt : 24;
  return React.createElement("div", {
              className: "font-montserrat flex flex-col items-center bg-bg2 py-[10px] rounded w-[66px]"
            }, React.createElement("div", {
                  className: CssJs.merge([
                        "flex items-center font-semibold pb-[4px]",
                        CssJs.style([
                              CssJs.lineHeight(CssJs.px(24)),
                              CssJs.fontSize(CssJs.px(numFontSize))
                            ])
                      ])
                }, Belt_Option.mapWithDefault(icon, null, (function (icon) {
                        return React.createElement("div", {
                                    className: "w-[22px] h-[22px] ml-[-5px] mr-[1px]"
                                  }, icon);
                      })), React.createElement("div", undefined, num, Belt_Option.mapWithDefault(suffix, null, (function (suffix) {
                            return React.createElement("span", {
                                        className: "text-base leading-none"
                                      }, suffix);
                          })))), React.createElement("div", {
                  className: "text-[15px]"
                }, label));
}

var Cell = {
  make: PlCurrentPerformance$Cell
};

function PlCurrentPerformance$Contents(Props) {
  var allRankedGames = Props.allRankedGames;
  var setExpandedMatchId = Props.setExpandedMatchId;
  var queueId = Props.queueId;
  var set = TftSet.use(undefined);
  var basePath4 = CdnAtom.usePath4(undefined);
  var recentMatches = Belt_Array.slice(allRankedGames, 0, 20);
  var before = Belt_Array.reverse(recentMatches).find(function (mi) {
        return Belt_Option.isSome(mi.rankBefore);
      });
  var after = recentMatches.find(function (mi) {
        return Belt_Option.isSome(mi.rankAfter);
      });
  var lpDelta;
  if (before !== undefined && after !== undefined) {
    var before$1 = Belt_Option.getExn(before.rankBefore);
    var after$1 = Belt_Option.getExn(after.rankAfter);
    lpDelta = (LpChartUtils.divisionToBase(after$1[0], set) + after$1[1] | 0) - (LpChartUtils.divisionToBase(before$1[0], set) + before$1[1] | 0) | 0;
  } else {
    lpDelta = undefined;
  }
  var isHot = Belt_Array.getExn(recentMatches, 0).info.placement <= 4;
  var streakLength = allRankedGames.findIndex(function (mi) {
        return mi.info.placement <= 4 !== isHot;
      });
  var streakLength$1 = streakLength === -1 ? allRankedGames.length : streakLength;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex items-end text-xl font-montserrat font-medium leading-none pb-2"
                }, React.createElement("div", undefined, "Recent " + String(recentMatches.length) + " Matches"), React.createElement("div", {
                      className: "pl-[4px] pb-[1px] text-base leading-none text-white2"
                    }, " (" + PlUtils.queueName(queueId) + ")")), React.createElement("div", {
                  className: "flex flex-col sm:flex-row items-start sm:items-center"
                }, React.createElement("div", {
                      className: CssJs.merge([
                            "grid gap-[5px]",
                            CssJs.style([CssJs.gridTemplateColumns([{
                                          NAME: "repeat",
                                          VAL: [
                                            {
                                              NAME: "num",
                                              VAL: 10
                                            },
                                            CssJs.auto
                                          ]
                                        }])])
                          ])
                    }, Belt_Array.map(Belt_Array.slice(recentMatches, 0, 20), (function (mi) {
                            return React.createElement(Tooltip.make, {
                                        classes: {
                                          tooltip: "max-w-[500px]"
                                        },
                                        title: React.createElement(PlShortMatchSummary.make, {
                                              hp: mi
                                            }),
                                        children: React.createElement("div", {
                                              className: "cursor-pointer",
                                              onClick: (function (param) {
                                                  return Curry._1(setExpandedMatchId, mi.id);
                                                })
                                            }, React.createElement(PositionSquare2.make, {
                                                  size: 26,
                                                  pl: mi.info.placement,
                                                  queueId: mi.queueId
                                                })),
                                        key: mi.id
                                      });
                          }))), React.createElement("div", {
                      className: "flex justify-evenly items-center pt-3 sm:pt-0 sm:pl-5 w-full sm:w-auto gap-[10px]"
                    }, React.createElement(PlCurrentPerformance$Cell, {
                          num: Global.toFixed(undefined, Global.f(Belt_Array.reduce(recentMatches, 0, (function (acc, m) {
                                          var place = queueId === 1160 ? (m.info.placement + 1 | 0) / 2 | 0 : m.info.placement;
                                          return acc + place | 0;
                                        }))) / Global.f(recentMatches.length)),
                          label: "Avg.",
                          numFontSize: 22
                        }), React.createElement(PlCurrentPerformance$Cell, {
                          num: String(Belt_Array.keep(recentMatches, (function (m) {
                                      return m.info.placement <= 4;
                                    })).length),
                          label: "Top 4"
                        }), React.createElement(PlCurrentPerformance$Cell, {
                          num: String(Belt_Array.keep(recentMatches, (function (m) {
                                      return m.info.placement <= (
                                              queueId === 1160 ? 2 : 1
                                            );
                                    })).length),
                          label: "Won"
                        }), React.createElement("div", {
                          className: "hidden xl:block"
                        }, React.createElement(PlCurrentPerformance$Cell, {
                              icon: React.createElement("img", {
                                    height: "22",
                                    src: basePath4 + "/general/" + (
                                      isHot ? "hot" : "cold"
                                    ) + ".png",
                                    width: "22"
                                  }),
                              num: String(streakLength$1),
                              label: "Streak"
                            })), React.createElement(PlCurrentPerformance$Cell, {
                          num: lpDelta !== undefined ? (
                              lpDelta > 0 ? "+" + String(lpDelta) : String(lpDelta)
                            ) : "-",
                          label: "LP",
                          numFontSize: lpDelta !== undefined && (lpDelta >= 100 || lpDelta <= -100) ? 22 : 24
                        }))));
}

var Contents = {
  make: PlCurrentPerformance$Contents
};

function PlCurrentPerformance(Props) {
  var allRankedGames = Props.allRankedGames;
  var setExpandedMatchId = Props.setExpandedMatchId;
  var queueId = Props.queueId;
  return React.createElement(ContentSection.make, {
              className: "lg:ml-6 mb-4 w-[336px] sm:w-[651px] xl:w-[727px] h-[193px] sm:h-[124px]",
              children: allRankedGames.length === 0 ? React.createElement("div", {
                      className: "w-full h-full flex items-center justify-center"
                    }, React.createElement("div", {
                          className: "text-xl text-white2 font-montserrat font-medium"
                        }, "No matches matching the selection")) : React.createElement(PlCurrentPerformance$Contents, {
                      allRankedGames: allRankedGames,
                      setExpandedMatchId: setExpandedMatchId,
                      queueId: queueId
                    })
            });
}

var make = PlCurrentPerformance;

export {
  Cell ,
  Contents ,
  make ,
  
}
/* CssJs Not a pure module */
